export default function () {
  return {
    valor_minimo: '6,53',
    compra: {
      cliente_id: null,
      formaPagamento: '',
      quantidade: '0,00',
    },
    compras: {
      data: [],
    },
  };
}
